export class UnvalidEmptyArrayError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "UnvalidEmptyArrayError"
    }
}